angular.module('qkr.refund').factory('refundService', (appConfig, $uibModal, $q, $http) => ({
    openTransRefundModal(trans) {
        return $uibModal.open({
            template: require('../../refund/templates/modal/refundTrans.html'),
            controller: 'refundTransController',
            windowClass: 'fade',
            size: 'sm',
            backdrop: 'static',
            resolve: {
                trans() {
                    return trans;
                }
            }
        });
    },

    openTransItemRefundModal(trans, transItem) {
        return $uibModal.open({
            template: require('../../refund/templates/modal/refundTransItem.html'),
            controller: 'refundTransItemController',
            windowClass: 'fade',
            size: 'sm',
            backdrop: 'static',
            resolve: {
                trans() {
                    return trans;
                },
                transItem() {
                    return transItem;
                }
            }
        });
    },

    openTransRefundHistoryModal(trans) {
        return $uibModal.open({
            template: require('../../refund/templates/modal/transRefundHistory.html'),
            controller: 'transRefundHistoryController',
            windowClass: 'fade',
            size: 'sm',
            backdrop: 'static',
            resolve: {
                transId() {
                    return trans.id;
                },
                currency() {
                    return trans.currency;
                }
            }
        });
    },

    refundTrans(refundTransCommand) {
        const deferred = $q.defer();

        $http.post(appConfig.apiUrl + 'refund/refundTrans', refundTransCommand)
            .then((response) => {
                deferred.resolve(response.data);
            }, (reason) => {
                deferred.reject(reason.data);
            });

        return deferred.promise;
    },

    refundTransItem(refundTransItemCommand) {
        const deferred = $q.defer();

        $http.post(appConfig.apiUrl + 'refund/refundTransItem', refundTransItemCommand)
            .then((response) => {
                deferred.resolve(response.data);
            }, (reason) => {
                deferred.reject(reason.data);
            });

        return deferred.promise;
    }
}));



// WEBPACK FOOTER //
// ./src/refund/services/refund.service.js